// extracted by mini-css-extract-plugin
module.exports = {"shareList":"b3_ft","shareListItem":"b3_gz","iconButton":"b3_gB"};